"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuctionTypes = void 0;
const AuctionTypes = exports.AuctionTypes = {
  Biddable: [13, 14, 16, 25, 37, 38],
  BuyItNowNonFastTransfer: [11, 23],
  BuyItNowOfferCounterOffer: [10, 15],
  BuyItNowNonCloseout: [20, 39],
  MemberOfferCounterOffer: [9, 33]
};